import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ArticleCategoryDTO } from '@scip/api';
import { TreeNode } from 'primeng/api';
import { translationKeys } from '../../../core';

@Component({
  selector: 'scip-article-category-select-dialog',
  templateUrl: './article-category-select-dialog.component.html',
  styleUrls: ['./article-category-select-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ArticleCategorySelectDialogComponent {
  @Input()
  set selectedCategories(val: ArticleCategoryDTO[]) {
    if (val && val.length !== 0) {
      this._selectedCategories = this.sortCategories(val);
    }
  }

  get selectedCategories(): ArticleCategoryDTO[] {
    return this._selectedCategories;
  }

  @Output() readonly saveEvent: EventEmitter<ArticleCategoryDTO[]> = new EventEmitter<ArticleCategoryDTO[]>();
  @Output() readonly cancelEvent: EventEmitter<void> = new EventEmitter<void>();

  selectedRightNode: ArticleCategoryDTO;
  selectedLeftNode: TreeNode;
  showDialog = true;
  translationKeys: typeof translationKeys = translationKeys;

  private _selectedCategories: ArticleCategoryDTO[] = [];

  removeSelectedNode(): void {
    this._selectedCategories.splice(this._selectedCategories.indexOf(this.selectedRightNode), 1);
    this.updateAfterTransfer();
  }

  removeAll(): void {
    this._selectedCategories = [];
    this.updateAfterTransfer();
  }

  setSelectedNode(nodeAvailableArticleCategory: TreeNode): void {
    this.selectedLeftNode = nodeAvailableArticleCategory;
    this.selectedRightNode = undefined;
  }

  setSelectedArticleCategoryRight(selectedArticleCategory: ArticleCategoryDTO): void {
    this.selectedLeftNode = undefined;
    this.selectedRightNode = selectedArticleCategory;
  }

  transferSelection(): void {
    const found = this._selectedCategories.find(
      ({ categorySpecificIdentifier }: ArticleCategoryDTO) => this.selectedLeftNode.data?.categorySpecificIdentifier === categorySpecificIdentifier
    );
    // Add selected node to article category selection only if taric code not already contained in selection
    if (!found) {
      this._selectedCategories.push(this.selectedLeftNode.data);
    }
    this.updateAfterTransfer();
  }

  private updateAfterTransfer(): void {
    // No matter in which direction we transfer something we discard the selection on both sides
    this.selectedRightNode = undefined;
    this.selectedLeftNode = undefined;
    this._selectedCategories = this.sortCategories(this._selectedCategories); // For primeNG onPush changedetection
  }

  private sortCategories(unsortedCategories: ArticleCategoryDTO[]): ArticleCategoryDTO[] {
    // Sort mutates the array, because of primeNG we need a new one, therefore spread it ;)
    return [...unsortedCategories.sort((a, b) => (a.id > b.id ? 1 : b.id > a.id ? -1 : 0))];
  }
}
